var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTloadLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 51,
    viewBox: "0 0 140 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.988 35V9.8H36.82V30.248H49.456V35H30.988ZM64.5327 35.432C62.5407 35.432 60.6927 35.108 58.9887 34.46C57.3087 33.812 55.8447 32.9 54.5967 31.724C53.3727 30.548 52.4127 29.168 51.7167 27.584C51.0447 26 50.7087 24.272 50.7087 22.4C50.7087 20.528 51.0447 18.8 51.7167 17.216C52.4127 15.632 53.3847 14.252 54.6327 13.076C55.8807 11.9 57.3447 10.988 59.0247 10.34C60.7047 9.692 62.5287 9.368 64.4967 9.368C66.4887 9.368 68.3127 9.692 69.9687 10.34C71.6487 10.988 73.1007 11.9 74.3247 13.076C75.5727 14.252 76.5447 15.632 77.2407 17.216C77.9367 18.776 78.2847 20.504 78.2847 22.4C78.2847 24.272 77.9367 26.012 77.2407 27.62C76.5447 29.204 75.5727 30.584 74.3247 31.76C73.1007 32.912 71.6487 33.812 69.9687 34.46C68.3127 35.108 66.5007 35.432 64.5327 35.432ZM64.4967 30.464C65.6247 30.464 66.6567 30.272 67.5927 29.888C68.5527 29.504 69.3927 28.952 70.1127 28.232C70.8327 27.512 71.3847 26.66 71.7687 25.676C72.1767 24.692 72.3807 23.6 72.3807 22.4C72.3807 21.2 72.1767 20.108 71.7687 19.124C71.3847 18.14 70.8327 17.288 70.1127 16.568C69.4167 15.848 68.5887 15.296 67.6287 14.912C66.6687 14.528 65.6247 14.336 64.4967 14.336C63.3687 14.336 62.3247 14.528 61.3647 14.912C60.4287 15.296 59.6007 15.848 58.8807 16.568C58.1607 17.288 57.5967 18.14 57.1887 19.124C56.8047 20.108 56.6127 21.2 56.6127 22.4C56.6127 23.576 56.8047 24.668 57.1887 25.676C57.5967 26.66 58.1487 27.512 58.8447 28.232C59.5647 28.952 60.4047 29.504 61.3647 29.888C62.3247 30.272 63.3687 30.464 64.4967 30.464ZM79.0041 35L90.2361 9.8H95.9961L107.264 35H101.144L91.9281 12.752H94.2321L84.9801 35H79.0041ZM84.6201 29.6L86.1681 25.172H99.1281L100.712 29.6H84.6201ZM109.879 35V9.8H121.327C124.063 9.8 126.475 10.328 128.563 11.384C130.651 12.416 132.283 13.868 133.459 15.74C134.635 17.612 135.223 19.832 135.223 22.4C135.223 24.944 134.635 27.164 133.459 29.06C132.283 30.932 130.651 32.396 128.563 33.452C126.475 34.484 124.063 35 121.327 35H109.879ZM115.711 30.212H121.039C122.719 30.212 124.171 29.9 125.395 29.276C126.643 28.628 127.603 27.716 128.275 26.54C128.971 25.364 129.319 23.984 129.319 22.4C129.319 20.792 128.971 19.412 128.275 18.26C127.603 17.084 126.643 16.184 125.395 15.56C124.171 14.912 122.719 14.588 121.039 14.588H115.711V30.212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.208 35V14.552H4.144V9.8H26.104V14.552H18.04V35H12.208Z",
    fill: "#F7931E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_5",
    x: 0.143997,
    y: 9.368,
    width: 139.079,
    height: 34.064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_5",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTloadLogo);
export default __webpack_public_path__ + "static/media/TloadLogo.3515cdc6750768980e098b4c5c437b46.svg";
export { ForwardRef as ReactComponent };